export default {
    props: ["open", "menu"],
    methods: {
        onOutsideClick() {
            this.$root.$emit("BurgerButton");
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/ClickOutside/ClickOutside.js